import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Button, Collapse, Container, FormControlLabel, Grid, Stack } from '@mui/material';
import { gold, fontBrand, TypographyBrand, ButtonBrand, black, white } from '../../../../getLPTheme';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import GolfCourseIcon from '@mui/icons-material/GolfCourse';
import LoyaltyIcon from '@mui/icons-material/Loyalty';
import LocalPostOfficeIcon from '@mui/icons-material/LocalPostOffice';
import DraftsIcon from '@mui/icons-material/Drafts';
import RestaurantMenuIcon from '@mui/icons-material/RestaurantMenu';
import { options } from '@config';
import { useAppDispatch } from '../../../../hooks'
import { incrementByAmount, reset  } from '../../counterSlice';
import Checkbox from '@mui/material/Checkbox';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import WavingHandIcon from '@mui/icons-material/WavingHand';
import SportsGolfIcon from '@mui/icons-material/SportsGolf';

export default function Notifications ({items}) {

    const dispatch = useAppDispatch()

    const userId = localStorage.getItem("CLUB-VIP-USER")

    const notifications = items.notifications

    const [notificationsMap, setNotificationsMap] = React.useState(new Map());

    const [notificationsMapFilter, setNotificationsMapFilter] = React.useState(new Map());

    const [checkedAll, setCheckedAll] = React.useState(false);

    const [myArrayupdated, setMyArrayupdated] = React.useState({});

    // Filter
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const [selectedIndex, setSelectedIndex] = React.useState(0);
    const open = Boolean(anchorEl);
    const handleClickListItem = (event: React.MouseEvent<HTMLElement>) => {
      setAnchorEl(event.currentTarget);
    };

    const optionsFilter = [
        'Todos',
        'Leídos',
        'No Leídos',
        'Fecha Asc.',
        'Fecha Desc.',
    ];

    const handleMenuItemClick = (
        event: React.MouseEvent<HTMLElement>,
        index: number,
      ) => {
        setSelectedIndex(index);
        setAnchorEl(null);
        handleFilter()
      };
    
      const handleClose = () => {
        setAnchorEl(null);
      };

    const handleFilter = async () => {

        let myArray = Array.from(notificationsMap.values())

        notificationsMapFilter.clear()

        if ( selectedIndex === 0 ) {
            //todos
            console.log("todos")
            let arrayFilter = myArray
            arrayFilter.map((elemento) => setNotificationsMapFilter(new Map(notificationsMapFilter.set(elemento.id, elemento))))
        } else if (selectedIndex === 1){
            // Leídos
            let arrayFilter = myArray.filter( item => item.status === "read" )
            console.log("leidos")

            arrayFilter.map((elemento) => setNotificationsMapFilter(new Map(notificationsMapFilter.set(elemento.id, elemento))))
            
        } else if (selectedIndex === 2){
            // No Leídos
            let arrayFilter = myArray.filter( item => item.status === "unread" )

            arrayFilter.map((elemento) => setNotificationsMapFilter(new Map(notificationsMapFilter.set(elemento.id, elemento))))

        } else if (selectedIndex === 3) {
            // Fecha Asc
            let ordered = myArray.sort((a, b) => {
                let yearA = new Date (a.date)
                let yearB = new Date (b.date)
                if (yearA > yearB) {
                  return 1;
                }
                return -1;
            });
            let arrayFilter = ordered

            arrayFilter.map((elemento) => setNotificationsMapFilter(new Map(notificationsMapFilter.set(elemento.id, elemento))))

        } else if (selectedIndex === 4) {
            // Fecha Desc
            let ordered = myArray.sort((a, b) => {
                let yearA = new Date (a.date)
                let yearB = new Date (b.date)
                if (yearA > yearB) {
                  return -1;
                }
                return 1;
            });
            let arrayFilter = ordered
            arrayFilter.map((elemento) => setNotificationsMapFilter(new Map(notificationsMapFilter.set(elemento.id, elemento))))
        }
    }

    React.useEffect(() => {
        handleFilter()
    }, [selectedIndex]);

    // Fin Filter

    React.useEffect(() => {
        //Relleno el mapa con la info
        notifications.map((elemento) => setNotificationsMap(new Map(notificationsMap.set(elemento.id, elemento))))
        setNotificationsMapFilter(notificationsMap)
    }, []);
    
    const handleDate = (fecha: string) => {
        let date = new Date(fecha)
        let newDate = `${date.getDate()}-${date.getMonth()+1}-${date.getFullYear()}`
        return newDate
    }

    const handleChangeCheckbox = (id) => {

        let updatedCheckedState = notificationsMapFilter

        let element = updatedCheckedState.get(id)

        let elementUpdate = {...element, checked: !updatedCheckedState.get(id).checked}

        setNotificationsMapFilter(new Map(notificationsMapFilter.set(id, elementUpdate)))

        let Myarray = {"notifications":Array.from(notificationsMap.values())}
        setMyArrayupdated( Myarray )

    };

    const handleChangeCheckboxAll = () => {

        setCheckedAll(!checkedAll)

        Array.from(notificationsMapFilter.keys()).map((item) => {
            notificationsMapFilter.get(item).checked = !checkedAll
        })
        setNotificationsMapFilter(notificationsMapFilter)
        let Myarray = {"notifications":Array.from(notificationsMap.values())}
        setMyArrayupdated( Myarray )

        console.log("notificationsMap",notificationsMap)
    };

    const handleClick = (id: any) => {
        if (notificationsMapFilter.get(id).status === 'read') {
            return
        } else {
            let myArray = notificationsMapFilter.get(id)
            myArray.status = "read"
            setNotificationsMapFilter(new Map(notificationsMapFilter.set(id, myArray)))
        }

        let Myarray = {"notifications":Array.from(notificationsMap.values())}
        setMyArrayupdated( Myarray )
    };

    // Cada vez que se actualice "notificationsMap" se ejecuta el handle
    React.useEffect(() => {
        handleSubmit()
        // handleListNotificationsUnread()
    }, [myArrayupdated]);


    const handleUrl  = (id: any) => {

        if (notificationsMap.get(id).icon === 'debt') {
            const url = `/`
            return url
        } else if (notificationsMap.get(id).icon === 'hello') {
            const url =`/`
            return url
        } else if (notificationsMap.get(id).icon === 'others') {
            const url =`/`
            return url
        } else {
            const url = `/notificaciones/${id}`
            return url
        }
    }

    const handleListNotificationsUnread = async () => {
        // Contador para el icono de notificaciones
        let contadorAux = 0
        let myArrayupdate = Array.from(notificationsMap.keys())
        for (let i = 0; i < myArrayupdate.length; i++) {
            if (notificationsMap.get(myArrayupdate[i]).status === 'unread') contadorAux++;; 
        }
        dispatch(reset())
        dispatch(incrementByAmount(contadorAux))
    }


    const handleDelete = async () => {

        setCheckedAll(false)

        let notificationsUpdate = notificationsMapFilter

        Array.from(notificationsMapFilter.keys()).map((item) => {
            if (notificationsMapFilter.get(item).checked === true) {
                notificationsUpdate.delete(item)
                notificationsMap.delete(item)
            }
        })

        Array.from(notificationsUpdate.keys()).map((item) => setNotificationsMap(new Map(notificationsMap.set(item, notificationsUpdate.get(item)))))
        Array.from(notificationsUpdate.keys()).map((item) => setNotificationsMapFilter(new Map(notificationsMapFilter.set(item, notificationsUpdate.get(item)))))

        if (notificationsUpdate.size === 0 && notificationsMap.size === 0) {
            notificationsMap.clear()
            notificationsMapFilter.clear()
            let Myarray = {"notifications": [{}]}
            setMyArrayupdated(Myarray)
            setSelectedIndex(0)
        } else if (notificationsUpdate.size === 0 && notificationsMap.size > 0) {
            notificationsMapFilter.clear()
            let Myarray = {"notifications":Array.from(notificationsMap.values())}
            setMyArrayupdated( Myarray )
            setSelectedIndex(0)
        } else {
            let Myarray = {"notifications":Array.from(notificationsMap.values())}
            setMyArrayupdated( Myarray )
        }

    }


    const handleSubmit = async () => {

        const response = await fetch((options.api.url + "notificationsuserid" + `?uid=${userId}`), {
            method: 'PUT',
            mode: "cors",
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(myArrayupdated),
        });

        // const error = await response.json();
        // Actualiza los datos del usuario

        handleListNotificationsUnread()

    };

    const icons: Record<any, { icon: React.ReactElement }> = {
        read: {
          icon: <DraftsIcon sx={{color: black[1000]}}/>,
        },
        unread: {
          icon: <LocalPostOfficeIcon sx={{color: black[1000]}}/>,
        },
        comercio: {
          icon: <RestaurantMenuIcon/>,
        },
        restaurant: {
          icon: <LoyaltyIcon/>,
        },
        club: {
          icon: <GolfCourseIcon/>,
        },
        debt: {
          icon: <WarningAmberIcon/>,
        },
        hello: {
            icon: <WavingHandIcon/>,
        },
        others: {
            icon: <SportsGolfIcon/>,
        },
    };


    const colors: Record<any, { colorText: string, colorBg: string, colorHover: string  }> = {
        read: {
            colorText: black[1000],
            colorBg: white[200],
            colorHover: white[400],
        },
        unread: {
            colorText: white[100],
            colorBg: gold[600],
            colorHover: gold[400],
        },
    }

    return (
        <Box>
            <Container sx={{display: 'flex',flexDirection: 'column',alignItems: 'center',}}>
            <Stack spacing={1} useFlexGap sx={{width: { xs: '100%', sm: '100%' } }}>
                <Grid container spacing={3} sx={{p:0, m:0}}>
                    <Grid item xs={5} md={5} lg={5} sx={{m:0, p:0}}>
                        <Box sx={{width: "100%", display: "flex", justifyContent: 'flex-start'}}>                    
                            <FormControlLabel
                                value="bottom"
                                control={ <Checkbox checked={checkedAll} onClick={handleChangeCheckboxAll} sx={{color: white[100],'&.Mui-checked': {color: gold[600],},}}/> }
                                label="Seleccionar todos"
                                labelPlacement="end"
                                sx={{p:0, color: white[100]}}
                            />
                            <Button onClick={() => {handleDelete()}} sx={{m:1, color: colors['read'].colorText, backgroundColor: colors['unread'].colorBg, height:30, width: 'auto', ":hover":{backgroundColor: colors['unread'].colorHover}}} type='submit' variant="contained"  > Borrar </Button>  
                        </Box>
                    </Grid>
                    <Grid item xs={2} md={2} lg={2}></Grid>

                    {/* <Grid item xs={5} md={5} lg={5} >
                        <Box sx={{width: "100%", display: "flex", justifyContent: 'flex-end'}}>
                            <Button onClick={() => {handleFilter()}}  sx={{m:1, p:1, color: colors['read'].colorText, backgroundColor: colors['unread'].colorBg, height:30, width: 'auto', ":hover":{backgroundColor: colors['unread'].colorHover}}} type='submit' variant="contained"  > <FilterAltIcon sx={{}}/> Filtros </Button>  
                        </Box>
                    </Grid> */}

                    <Grid item xs={5} md={5} lg={5}>
                    <Box sx={{width: "100%", display: "flex", justifyContent: 'flex-end'}}> 
                    <List component="nav" aria-label="Device settings" sx={{m:1, p:0, backgroundColor: colors['unread'].colorBg, color: colors['read'].colorText, height:30, width: 'auto'}}>
                        <ListItemButton
                            id="lock-button"
                            aria-haspopup="listbox"
                            aria-controls="lock-menu"
                            aria-label="Filtros"
                            aria-expanded={open ? 'true' : undefined}
                            onClick={handleClickListItem}
                            sx={{height:30, width: 'auto', m:0, pl: 0.2}}
                        >
                            <FilterAltIcon sx={{m:0, pr:1}}/>
                            <ListItemText
                                // primary="Filtros"
                                secondary={optionsFilter[selectedIndex]}
                            />
                            
                        </ListItemButton>
                        
                    </List>
                    
                    <Menu
                        id="lock-menu"
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleClose}
                        MenuListProps={{
                        'aria-labelledby': 'lock-button',
                        role: 'listbox',
                        }}
                    >
                        {optionsFilter.map((option, index) => (
                        <MenuItem
                            key={option}
                            // disabled={index === 0}
                            selected={index === selectedIndex}
                            onClick={(event) => handleMenuItemClick(event, index)}
                        >
                         {option}
                        </MenuItem>
                        ))}
                    </Menu>
                    </Box>
                    </Grid>

                    {
                        
                        Array.from(notificationsMapFilter.keys()).map((item, index) => {
                            if (notificationsMapFilter.size === 0 || (notificationsMapFilter.size === 1 && notificationsMapFilter.has(undefined) === true)) {
                                return (
                                    <Box sx={{width: "100%", display: 'flex'}}>
                                        <TypographyBrand> No hay nuevas notificaciones </TypographyBrand>
                                    </Box>
                                )
                            } else {
                            return (
                                <Box sx={{m:0, width: "100%", display: 'flex'}}>
                                    <Checkbox checked={notificationsMapFilter.get(item).checked} onChange={() => handleChangeCheckbox(notificationsMapFilter.get(item).id)} sx={{m:1, p:0, color: white[100],'&.Mui-checked': {color: gold[600],},}}/>
                                    <Button href={handleUrl(notificationsMapFilter.get(item).id)} onClick={() => {handleClick(notificationsMapFilter.get(item).id)}} sx={{marginTop:1, marginBottom:1, marginLeft:0, marginRight:0, color: colors[notificationsMapFilter.get(item).status].colorText, backgroundColor: colors[notificationsMapFilter.get(item).status].colorBg, height:55, width: "100%", ":hover":{backgroundColor: colors[notificationsMapFilter.get(item).status].colorHover}}} type='submit' variant="contained"  >
                                        <Grid item xs={1} md={1} lg={1} sx={{m:0}}>
                                            <Box sx={{m:0, display: "flex", justifyContent: "flex-start", alignItems: "center", width: "10%"}}>
                                                {icons[notificationsMapFilter.get(item).status].icon}
                                            </Box>
                                        </Grid>
                                        <Grid item xs={9} md={9} lg={9}>
                                            <TypographyBrand fontFamily={fontBrand.secundaria} sx={{color: black[1000], fontSize: {sm: '1.3vw', xs: '3.0vw'}, display: 'flex',flexDirection: { xs: 'column', md: 'row' },alignSelf: 'center',textAlign: 'center',}}>
                                                <Box sx={{display: "flex", justifyContent: "center", alignItems: "center"}}>
                                                    {icons[notificationsMapFilter.get(item).icon].icon}
                                                    <Box sx={{m:1}}>
                                                        {notificationsMapFilter.get(item).message} 
                                                    </Box> 
                                                </Box>
                                            </TypographyBrand>
                                        </Grid>
                                        <Grid item xs={2} md={2} lg={2} sx={{m:0}}>
                                            <Box sx={{m:0, p:0, display: "flex", justifyContent: 'flex-end', alignItems: "center"}}>
                                                <TypographyBrand fontFamily={fontBrand.secundaria} sx={{m:0, p:0, color: black[1000], fontSize: {sm: '1.3vw', xs: '3.0vw'}, display: 'flex',flexDirection: { xs: 'column', md: 'row' },alignSelf: 'center',textAlign: 'center',}}>
                                                    <Box sx={{m:0, p:0}}>
                                                        {handleDate(notificationsMapFilter.get(item).date)}  
                                                    </Box> 
                                                </TypographyBrand>
                                            </Box>
                                        </Grid>
                                    </Button>
                                </Box>
                            )
                        }
                        })
                    }
                </Grid>
                </Stack>
            </Container>
        </Box> 
    )
}
  